module.exports = __webpack_public_path__ + "static/front-training-mobile-414da5d6c003c6435376096bc15eacbe.jpg";